import React from 'react';
import parse from "html-react-parser";
import './Modelo3DCard.css';
import ProductTypeBadge from '../../../../../../../products/ProductTypeBadge.jsx';

const Modelo3DCard = ({ model, onModeloSelect, isSelected }) => {


    function removeWidthAndHeightAttributes(svgString) {
        // Use regular expression to remove the width and height attributes
        return svgString.replace(/width="[^"]*"/, '').replace(/height="[^"]*"/, '');
    }
    // console.log('model:', model)

    return (
        <div
            onDoubleClick={() => onModeloSelect(model)}
            className={`bg-white dark:bg-gray-800 relative rounded-lg border border-gray-200 dark:border-gray-700 shadow-md transition-transform transform hover:scale-105 hover:shadow-lg modelo-3d-card cursor-pointer ${isSelected ? 'selected' : ''}`}
        >
            <div className="absolute top-2 right-2 z-20">
                <ProductTypeBadge modelo={model} compact />
            </div>
            <div className="bg-gray-100 dark:bg-gray-700 w-full rounded-lg z-50 aspect-w-1 aspect-h-1 flex items-center justify-center">
                {/* Aquí puedes mostrar una vista previa del modelo 3D o un ícono */}

                <div className="p-2 min-h-full min-w-full object-contain bg-none">
                     {model.svg_2d && parse(removeWidthAndHeightAttributes(model.svg_2d))}
                </div>
            </div>

            <div className="p-4 text-center overflow-hidden">
                <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-300 capitalize">
                    {model.name}
                </h3>
                {/* Puedes añadir más detalles del modelo aquí si es necesario */}
            </div>
        </div>
    );
};

export default Modelo3DCard;
